import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'


import { isHexCode } from '@/shared/modules/colorHelpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'ColorBadge',
  props: {
  color: {
    type: String,
    validator: isHexCode,
    required: true,
    default: '#FFFFFF',
  },
  label: {
    type: String,
    required: false,
    default: ' ',
  },
},
  setup(__props) {

_useCssVars((_vm, _setup) => ({
  "1b905369": (_vm.color)
}))



return { __sfc: true, }
}

})